import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const useFunnelConfig = () => {
  const [config, setConfig] = useState({ event_date: '', event_time: '', event_start_iso: '', community_url: 'https://www.skool.com/voxinity-ai' });
  useEffect(() => {
    axios.get(`${API}/api/funnel/config`).then((r) => setConfig(r.data)).catch(() => {});
  }, []);
  return config;
};

export const displayDate = (config) => config.event_date || '[DATE]';
export const displayTime = (config) => config.event_time || '[TIME]';

// Accepts a full Wistia embed code, any Wistia URL, or a bare media ID →
// returns the clean player-only iframe URL. Empty string if unparseable.
export const wistiaEmbed = (raw) => {
  if (!raw) return '';
  const input = raw.trim();
  const params = 'seo=false&videoFoam=true&playerColor=141414';
  // Async embed code: class="wistia_async_{id}"
  const asyncMatch = input.match(/wistia_async_([a-zA-Z0-9_-]+)/);
  if (asyncMatch) return `https://fast.wistia.net/embed/iframe/${asyncMatch[1]}?${params}`;
  // Any Wistia URL or iframe embed code with the media id in it
  const urlMatch = input.match(/(?:medias|embed\/iframe)\/([a-zA-Z0-9_-]+)/);
  if (urlMatch) return `https://fast.wistia.net/embed/iframe/${urlMatch[1]}?${params}`;
  // ?wvideo= share links
  const wvideoMatch = input.match(/[?&]wvideo=([a-zA-Z0-9_-]+)/);
  if (wvideoMatch) return `https://fast.wistia.net/embed/iframe/${wvideoMatch[1]}?${params}`;
  // Bare media ID
  if (/^[a-zA-Z0-9_-]{5,20}$/.test(input)) return `https://fast.wistia.net/embed/iframe/${input}?${params}`;
  // A Wistia link with no recognizable media id (e.g. a project/folder link) → invalid
  if (/wistia/i.test(input)) return '';
  // Some other host's direct URL — use as-is
  if (/^https?:\/\//.test(input)) return input;
  return '';
};

export const googleCalUrl = (config) => {
  if (!config.event_start_iso) return null;
  const start = new Date(config.event_start_iso);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent('The 1-Day AI Agency Challenge')}&dates=${fmt(start)}/${fmt(end)}&details=${encodeURIComponent('Live session — bring your list of 3 local businesses.')}`;
};

export const downloadIcs = (config) => {
  if (!config.event_start_iso) return;
  const start = new Date(config.event_start_iso);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', `DTSTART:${fmt(start)}`, `DTEND:${fmt(end)}`,
    'SUMMARY:The 1-Day AI Agency Challenge', 'DESCRIPTION:Live session — bring your list of 3 local businesses.',
    'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
  const blob = new Blob([ics], { type: 'text/calendar' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'ai-agency-challenge.ics';
  a.click();
};
